export const getImageUri = (image, { blobImageSizeFolder = 'large' } = {}) =>
  (image.src ?? image.imageUri ?? '')
    ?.replace('fieldrepimage', 'fieldrepimagelarge')
    .replace('/raw/', `/${blobImageSizeFolder}/`);
